
  import { defineComponent, PropType } from 'vue';

  import { TStatisticsPublicFilter } from '../../../types/statistics/statistics-public';
  import StatisticsViewsCountTabs from '../StatisticsViewsCountTabs.vue';
  import StatisticsPublicViewsCountByNavigationTab from './StatisticsPublicViewsCountByNavigationTab.vue';
  import StatisticsPublicViewsCountByTimeTab from './StatisticsPublicViewsCountByTimeTab.vue';

  export default defineComponent({
    name: 'StatisticsPublicViewsCountTabs',
    components: {
      StatisticsViewsCountTabs,
      StatisticsPublicViewsCountByNavigationTab,
      StatisticsPublicViewsCountByTimeTab,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPublicFilter>,
        required: true,
      },
    },
  });
